export const DEBOUNCE_MS = 350;
export const PAGE_SIZE = 50;
